
<template>
	<c-dialog ref="dialog" mode="slide" width="100vw-300" mask-close @close="dialogFormEditConfirm($refs.defaultForm, arguments)" @resolve="submitHandle">
		<c-form ref="defaultForm" column="3" vertical unit-width="100%">
			<c-title>排产明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" view-id="10018" work-type="3" batch-edit>
					<template #operate>
						<c-button color="main" prepend-icon="tf-add" @click="globalDialog('productSelector', {props: {initParam: {product_sources:[1]}}}, productSelectorHandle)">添加产品</c-button>
					</template>

					<template #otherOperate>
						<c-button prepend-icon="tf-edit" v-if="ref_type == 1" @click="workDatebyOrder()">按订单交期填充结束时间</c-button>
						<c-button color="red" hollow prepend-icon="tf-clear" @click="clearNonData()">清除无效数据</c-button>
						<c-button v-if="auth('m_schedule_calendar')" v-lock="lock('m_schedule_calendar')" prepend-icon="tf-calendar" @click="windowTo({name: 'm_schedule_calendar'})">排产日历</c-button>
					</template>
					
					<!--关联订单号/计划单号-->
					<template #order_code="{data}">
						<span v-if="data.order_code">{{data.order_code}}</span>
						<span v-else>-</span>
					</template>
					
					<!--单据来源-->
					<template #ref_type="{data}">
						<c-state v-if="data.ref_type" dict="WorkRefTypeDic" :value="data.ref_type"></c-state>
						<span v-else style="color:#bbb">自建</span>
					</template>
					
					<!--产品类型-->
					<template #work_code="{data}">
						<span v-if="data.id">{{data.work_code}}</span>
						<span v-else>待生成</span>
					</template>
					
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					
					<!--产品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					
					<!--本次排产数-->
					<template #temp_scheduling_count="{data}">
						<c-input type="number" decimal="2" :range="[0.01,99999999]" v-model="data.temp_scheduling_count" :clear="false"></c-input>
					</template>
					
					<!--工单备注-->
					<template #remark="{data}">
						<c-input v-model="data.remark" type="textarea"></c-input>
					</template>
					
					<!--优先级-->
					<template #priority="{data}">
						<c-state dict="priorityDic" tag :value="data.priority"></c-state>
					</template>
					
					<!--计划开始时间-->
					<template #plan_start_date="{data}">
						<c-datetime type="datetime" v-model="data.plan_start_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
					</template>
					
					<!--计划结束时间-->
					<template #plan_end_date="{data}">
						<c-datetime type="datetime" v-model="data.plan_end_date" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
					</template>
					
					<c-table-column
                        type="button"
                        label="操作"
						width="110"
                    >
                        <template #default="{data,remove}">
							<c-table-button icon="tf-copy" @click="copyProductRow(data)">复制</c-table-button>
							<c-table-button icon="tf-trash" color="red" @click="removeProductRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'batchWorkEdit',

		data() {
			return {
				ref_type: 0
			}
		},

		methods: {
			open(data = {}) {
				//初始化产品列表控件
				this.$refs.productTable.init({
					formulaSource: {
						name: '工单'
					}
				});
				
				this.deleteProductList = [];
				//清空表单数据
				this.$refs.defaultForm.clear();
				
				if(data.ref_type){
					this.ref_type = data.ref_type;
				}
				
				if (data.orderProductList) {
					this.selectOrderProductHandle(data.orderProductList);
				}
				
				this.$refs.dialog.open({
					title: '批量生成工单'
				});
			},
			
			//按订单添加相应方法
			async selectOrderProductHandle(data) {
				this.$refs.productTable.$refs.list.push(
					await this.$refs.productTable.setDefaultData(data.map(item => {
						return Object.assign({}, item, {
							id: null,
							plan_count: item.main_product_count,
							temp_scheduling_count: (item.main_product_count - (item.scheduling_count||0))<0?0:(item.main_product_count - (item.scheduling_count||0)),
							create_date: null,
							create_user_realname: null,
							plan_start_date: new Date().format('yyyy-MM-dd 00:00'),
							plan_end_date: new Date().format('yyyy-MM-dd 23:59')
						});
					}), {
						work_type_id: 3,
						source_list: data.map(item => {
							return [{
								ref_work_type_id: 1,
								ref_id: item.order_id
							}, {
								ref_work_type_id: 41,
								ref_id: item.id
							}, {
								ref_work_type_id: 2,
								ref_id: item.order_id
							}, {
								ref_work_type_id: 48,
								ref_id: item.id
							}, {
								ref_work_type_id: 7,
								ref_id: item.product_id
							}]
						})
					})
				);
			},
			
			/******选择产品响应方法*********/
			async productSelectorHandle(data) {
				this.$refs.productTable.$refs.list.push(
					await this.$refs.productTable.setDefaultData(data.map(item => {
						return Object.assign({}, item, {
							product_id: item.id,
							id: null,
							plan_count: 1,
							create_date: null,
							create_user_realname: null,
							plan_start_date: new Date().format('yyyy-MM-dd 00:00'),
							plan_end_date: new Date().format('yyyy-MM-dd 23:59')
						});
					}), {
						work_type_id: 3,
						source_list: data.map(item => {
							return [{
								ref_work_type_id: 7,
								ref_id: item.id
							}]
						})
					})
				);
			},
			
			/******删除产品行数据********/
			removeProductRow(data, remove) {
				if (data.id && data.id > 0){
					this.deleteProductList.push(data.id);
				}
				remove();
			},
			
			/*****复制转单数据******/
			copyProductRow(data){
				this.$refs.productTable.$refs.list.push(data);
			},
			
			/**按订单交期填写工单计划结束时间**/
			workDatebyOrder(){
				const dataList = this.$refs.productTable.$refs.list.getRow();
				dataList.forEach(item => {
				    item.update({plan_end_date: item.data.plan_delivery_date});
				})
			},
			
			/**清除无效数据**/
			clearNonData(){
				const dataList = this.$refs.productTable.$refs.list.getRow();
				for (let i = dataList.length - 1; i >= 0; i--) {
				    const row = dataList[i];
				    const count = row.data?.temp_scheduling_count;
				    // 数量为空、undefined、null、0 都判定为无效
				    if (!count || Number(count) === 0) {
						row.remove();
				    }
				}
			},

			/*******提交编辑数据********************/
			submitHandle(stop, next) {
				stop();
				
				//产品工单列表
				var product_list = this.$refs.productTable.$refs.list.getData();
				
				this.$refs.defaultForm.submit({
					url: '/work/batchAdd',
					rule: {
						product_list: data => { 
							var flag = true;
							if(product_list.length == 0){
								let msg = "请至少有一个产品信息";
								return msg;
							} 
							var msg2;
							product_list.forEach(item => {
								if(!item.temp_scheduling_count || item.temp_scheduling_count ==0){
									msg2 = "存在本次排产数为0的数据，请填写或删除！";
									flag = false;
								}
							});
							if (!flag) {
								return msg2;
							}
							
							product_list.forEach(item => {
								if(!item.temp_scheduling_count || !item.plan_start_date || !item.plan_end_date){
									flag = false;
								}
							});

							if (!flag) {
								let msg = "请完善产品明细";
								return msg;
							}
							//自定义字段校验
							return this.$refs.productTable.validate();
						}
					},
					dataFormatter: data => {
						data.ref_type = this.ref_type||0;
						//产品列表
						data.product_list = product_list.map(item => {
							return {
								id: item.id,
								ref_id: item.order_id,
								order_id: item.order_id,
								order_product_id: item.order_product_id,
								product_id: item.product_id,
								plan_count: item.temp_scheduling_count,
								plan_start_date: item.plan_start_date,
								plan_end_date: item.plan_end_date,
								remark: item.remark,
								custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
							}
						});
						return data;
					},
					success: () => {
						next();
						this.$message({
							type: 'success',
							message:'批量生成工单成功',
						});
						//刷新页面
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>